import { http } from '@/core/api'

export type NavigationMenuRow = {
  menu_key: string
  parent_menu_key: string | null
  default_route_name: string | null
  label: string
  labels?: { vi?: string; en?: string; zh?: string }
  is_visible: boolean
  globally_visible: boolean
  allowed: boolean
  denial_reason: NavigationDenialReason
  sort_order: number
  permission_keys: string[]
}

export type NavigationRouteRow = {
  menu_key: string
  parent_menu_key: string | null
  permission_keys: string[]
  is_visible: boolean
  globally_visible: boolean
  allowed: boolean
  denial_reason: NavigationDenialReason
}

export type NavigationDenialReason = 'disabled' | 'forbidden' | null

export type NavigationPayload = {
  menus: NavigationMenuRow[]
  routes: Record<string, NavigationRouteRow>
}

export const navigationApi = {
  async fetchNavigation(): Promise<{ data: NavigationPayload }> {
    const { data } = await http.get<{ data: NavigationPayload }>('/auth/me/navigation')
    return data
  },
}
